import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Wicket_keeper"
      data-name="Wicket keeper"
      xmlns="http://www.w3.org/2000/svg"
      width={29}
      height={29}
      {...props}>
      <defs>
        <style>{`.prefix__cls-1{fill:${props.fillPrimary} !important}`}</style>
      </defs>
      <g id="prefix__Group_1620" data-name="Group 1620" transform="translate(6.484)">
        <path
          id="prefix__Path_5338"
          data-name="Path 5338"
          className="prefix__cls-1"
          d="M57.962 53a.738.738 0 01.486.754c0 .24.042.48.066.733l-3.1.291a10.713 10.713 0 01-.054-1.12.573.573 0 01.575-.485l1.537-.142a.667.667 0 00.111-.03z"
          transform="translate(-55.361 -53)"
        />
        <path
          id="prefix__Path_5339"
          data-name="Path 5339"
          className="prefix__cls-1"
          d="M457.864 53c.274.032.548.068.822.1s.552.05.828.075a.619.619 0 01.6.685q0 .11-.015.22l-.071.7-3.092-.289c.047-.37.079-.734.145-1.091.039-.211.237-.3.412-.394z"
          transform="translate(-442.792 -53)"
        />
        <path
          id="prefix__Path_5340"
          data-name="Path 5340"
          className="prefix__cls-1"
          d="M417.1 112.693l3.081.289c-.025.286-.048.561-.073.834l-.437 4.632-.463 4.869-.409 4.328c-.024.256-.127.343-.388.343h-2.328c-.292 0-.41-.116-.384-.4.08-.908.181-1.814.247-2.723.025-.342.636-6.669.644-6.758.126-1.375.259-2.75.39-4.125.041-.426.079-.847.12-1.289z"
          transform="translate(-403.006 -110.591)"
        />
        <path
          id="prefix__Path_5341"
          data-name="Path 5341"
          className="prefix__cls-1"
          d="M62.208 112.737l.235 2.475c.087.918.172 1.837.263 2.755.019.2.6 6.473.612 6.556.1 1.031.2 2.062.289 3.094.026.29-.087.414-.373.414h-2.328c-.278 0-.376-.094-.4-.368q-.23-2.442-.464-4.885-.2-2.071-.387-4.142t-.395-4.136c-.046-.484-.089-.968-.134-1.47z"
          transform="translate(-58.993 -110.633)"
        />
        <path
          id="prefix__Path_5342"
          data-name="Path 5342"
          className="prefix__cls-1"
          d="M260.232 131.186a.29.29 0 01-.314.291q-1.23.005-2.461 0c-.158 0-.3-.083-.3-.242a20.151 20.151 0 01-.008-.651l-.008.012V116.31h3.08v13.315c-.001.503.022 1.075.011 1.561z"
          transform="translate(-250.034 -114.08)"
        />
        <path
          id="prefix__Path_5343"
          data-name="Path 5343"
          className="prefix__cls-1"
          d="M260.886 55.768h-3.074a10.289 10.289 0 01.009-1.078.566.566 0 01.6-.471q.942 0 1.883.022a.59.59 0 01.577.559c.014.316.005.633.005.968z"
          transform="translate(-250.672 -54.176)"
        />
      </g>
      <g id="prefix__Group_2480" data-name="Group 2480" transform="translate(-228 -186)">
        <rect
          id="prefix__Rectangle_918"
          data-name="Rectangle 918"
          className="prefix__cls-1"
          width={29}
          height={11}
          rx={5.5}
          transform="translate(228 203)"
        />
        <text
          id="prefix__W_K"
          data-name="W/K"
          transform="translate(243 212)"
          fill={props.fillSecondary}
          fontSize={10}
          fontFamily="ProximaNova-Bold,Proxima Nova"
          fontWeight={700}>
          <tspan x={-9.415} y={0}>
            {'W/K'}
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default SvgComponent;
